import React from "react"
import { Spacer } from "../atoms/Atoms"
import { useSelector } from "react-redux"
import { getSubsidyStatus } from "reducers/subsidyStatus"
import L10n from "../../../lib/carrot-l10n"
import { Thermometer } from "../molecules/Thermometer"
import { getCurrencySymbol } from "reducers/companyInfo"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { CurrencyString } from "components/views/molecules/CurrencyString"
import { getIsBenefitLifetimeOnly } from "derivedSelectors"
import { PlanInfoBadgeContainer } from "components/containers/planinfo/PlanInfoBadgeContainer"
import { H2Library, H4 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ReimbursementsThermometer = () => {
  const currencySymbol = useSelector(getCurrencySymbol)
  const isBenefitLifetimeOnly = useSelector(getIsBenefitLifetimeOnly)
  const { yearlyUsed, lifetimeUsed, yearlyMax, yearlyProcessing, lifetimeProcessing, yearlyAvailable } = useSelector(
    getSubsidyStatus
  )

  const effectiveUsedAmount = isBenefitLifetimeOnly ? lifetimeUsed : yearlyUsed
  const effectiveProcessingAmount = isBenefitLifetimeOnly ? lifetimeProcessing : yearlyProcessing

  const usedBarPercentage = (effectiveUsedAmount / yearlyMax).toFixed(2) * 100
  const processingBarPercentage = usedBarPercentage + (effectiveProcessingAmount / yearlyMax).toFixed(2) * 100

  const bars = [
    {
      color: "carrot-medium-green",
      percentage: processingBarPercentage,
      label: "processing",
      value: effectiveProcessingAmount
    },
    {
      color: "dark-mint",
      percentage: usedBarPercentage,
      label: "used",
      value: effectiveUsedAmount
    }
  ]

  return (
    <div className="flex flex-column">
      <H4>{l`client.reimbursements.yourBalance`}</H4>
      <Spacer height={0.5} />
      <H2Library>
        <span id="transactions-available-benefit">
          <CurrencyString amount={Math.max(yearlyAvailable, 0)} />
        </span>
      </H2Library>
      <Thermometer
        currencySymbol={currencySymbol}
        maxValue={yearlyMax}
        minValue={0}
        barBackgroundColor="mint-alternate"
        bars={bars}
        callToAction={
          <ArrowLink to="/your-benefit-guide/about-your-benefit">{l`reimbursements.benefitDetails`}</ArrowLink>
        }
      />
      <Spacer height={1} />
      <PlanInfoBadgeContainer backgroundColor="light-grey" fontColor="black-60" />
    </div>
  )
}

export default ReimbursementsThermometer
